import { createSlice } from "@reduxjs/toolkit";
import { statisticApi } from "./statisticApi";

const initialState = {
  statistics: [],
  statisticsCount: null,
  statistic: null,
  updating: false,
  trashId: null,
};

const statisticsSlice = createSlice({
  name: "statisticsSlice",
  initialState,
  reducers: {
    setUpdating(state, action) {
      state.updating = action.payload;
    },
    setStatistic(state, action) {
      state.statistic = action.payload;
    },
    setTrashId(state, action) {
      state.trashId = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      statisticApi.endpoints.getStatistics.matchFulfilled,
      (state, action) => {
        state.statistics = action.payload.data.attributes.data;
        state.statisticsCount = action.payload.data.attributes.meta.count;
      }
    );
    builder.addMatcher(
      statisticApi.endpoints.getStatistic.matchFulfilled,
      (state, action) => {
        state.statistic = action.payload.data.attributes;
      }
    );
  },
});
export const { setUpdating, setStatistic, setTrashId } =
  statisticsSlice.actions;
export default statisticsSlice.reducer;
